import React from 'react';
import './MeetTheTeam.css';
import TeamImg from '../assets/Team.jpg';
import Footer from './Footer.tsx';

export default function MeetTheTeam() {
  return (
    <div className="meet-the-team-container">
      <section className="meet-the-team">
        {/* Title at the top */}
        <h1 className="team-title">MEET THE 2025 EXECUTIVE TEAM</h1>
        
        {/* Centered Team image */}
        <img
          src={TeamImg}
          alt="Our Team"
          className="team-photo"
        />
        <Footer />
      </section>
    </div>
  );
}